<div
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <div *ngIf="!loading" fxLayout="column" fxLayoutGap="12px" fxFill>
    <app-no-services *ngIf="services.length === 0"></app-no-services>
    <app-service-form
      *ngFor="let service of services"
      [formModel]="service"
      (deleted)="deleteService(service)"
    ></app-service-form>
  </div>
  <app-loading-spinner [(show)]="loading"></app-loading-spinner>

  <button
    matTooltip="Click to add a new Service"
    matTooltipPosition="left"
    matTooltipClass="add-service-tooltip"
    #fabTooltip="matTooltip"
    mat-fab
    class="corner-fab add-service"
    (click)="addService()"
  >
    +
  </button>
</div>
